import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Send: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm22 2-7 20-4-9-9-4Z' }],
    ['path', { d: 'M22 2 11 13' }],
  ],
];

export default Send;
